import { useMemo } from 'react';
import { DATE_FILTERS, DateFilter } from './DateFilter';

/**
 * Finds the selected date filter and it's value
 */
export function useDateFilterValue(
  search: Record<string, string | string[]>,
  filters: DateFilter[]
) {
  return useMemo(() => {
    if (!search) {
      return {};
    }

    // Match selected filter and it's value
    const matchedPair = Object.entries(search)?.find(([key]) =>
      Boolean(Object.values(DATE_FILTERS).includes(key as DateFilter))
    );

    // If none found return the default filter with an empty value
    const [selectedDateFilter, selectedDateFilterValue] = matchedPair ?? [
      filters[0],
      ''
    ];

    // Date range is encoded in the value as a string e.g. '2024-01-01,2024-01-31'
    // Let's extract it
    const [from, to] = ((selectedDateFilterValue as string) ?? '').split(',');
    const range = { from, to };

    return { selectedDateFilter: selectedDateFilter as DateFilter, range };
  }, [search]);
}
